import {
  getTokenUrl,
  getAllOrg, api2AdminByEmail
} from "../utils/operations";
import {makeObservable, observable, computed, action, runInAction} from "mobx";
import API from '../utils/api';

class AuthClass {
  user = null;
  show_finance = false;
  edit_finance = false;
  profile = null;
  role = null;
  availableOrgs = [];
  allOrgs = {};
  orgId = null;
  orgName = null;
  child_id = null;
  snackBar = false;
  menuVisible = false;
  pdfFile = "";
  addParentToChildId = null;

  constructor() {
    makeObservable(this, {
      user: observable,
      show_finance: observable,
      edit_finance: observable,
      profile: observable,
      role: observable,
      availableOrgs: observable,
      allOrgs: observable,
      orgId: observable,
      orgName: observable,
      child_id: observable,
      snackBar: observable,
      menuVisible: observable,
      pdfFile: observable,
      addParentToChildId: observable,
      isLoggedIn: computed,
      isSuperAdmin: computed,
      isManager: computed,
      isInvitationsSentForCurrentOrg: computed,
      init: action,
      login: action,
      getProfile: action,
      getOrgName: action,
      getAllOrgs: action,
      setUser: action,
      setOrgId: action,
      setMenuVisible: action,
      can: action,
      logout: action,
    })
  }
  get isLoggedIn() {
    return !!this.user;
  }

  get isSuperAdmin() {
    return this.role === "superadmin";
  }

  get isManager() {
    return this.role === "manager";
  }

  get isInvitationsSentForCurrentOrg() {
    return this.allOrgs.hasOwnProperty(this.orgId) && this.allOrgs[this.orgId].invitation_sent
  }

  async init() {
    if (localStorage.hasOwnProperty("token")) {
      runInAction(() => {
        this.orgId = localStorage.getItem('orgId', 1)
        this.user = JSON.parse(localStorage.getItem('user'))
      })
      await this.getProfile()
      await this.getOrgName()
    }
  }

  login(email, password) {
    return API.post(getTokenUrl, {
        email: email,
        password: password
      })
  }

  async getProfile() {
    return API.get(api2AdminByEmail, {params: {email: this.user.email}})
      .then(res => {
        const gotProfile = res.data.admin;
        const gotId = gotProfile.organisation_id === 0 ? 1 : gotProfile.organisation_id;

        localStorage.setItem("profile", JSON.stringify(gotProfile));

        runInAction(() => {
          this.role = gotProfile.role.name;
          this.profile = gotProfile;
          this.availableOrgs = res.data.organizations;

          if (this.role === "superadmin") {
            this.show_finance = true
            this.edit_finance = true
          } else {
            this.show_finance = this.role === "admin" ? res.data.admin.show_finance : false
            this.edit_finance = this.role === "admin" ? res.data.admin.edit_finance : false
          }
        })

        this.setOrgId(localStorage.getItem("orgId") || gotId)

        return gotProfile;
      });
  }

  getOrgName() {
    if (this.allOrgs.hasOwnProperty(this.orgId)) {
      this.orgName = this.allOrgs[this.orgId].name

      return new Promise((resolve) => {
        setTimeout(() => {
          resolve("success");
        }, 100);
      });
    } else {
      return API.get(getAllOrg).then(res => {
        let allOrgs = {}
        res.data.resource.forEach(item => allOrgs[item.id] = item)

        runInAction(() => {
          this.allOrgs = allOrgs
          this.orgName = this.allOrgs[this.orgId].name
        })
      });
    }
  }

  getAllOrgs() {
    return API.get(getAllOrg).then(res => {
      let allOrgs = {}
      res.data.resource.forEach(item => allOrgs[item.id] = item)
      runInAction(() => {
        this.allOrgs = allOrgs
      })
    });
  }

  setUser(value) {
    this.user = value
    localStorage.setItem("token", value.session_token);
    localStorage.setItem("user", JSON.stringify(value));
  }

  setOrgId(value) {
    this.orgId = value.toString()
    localStorage.setItem("orgId", this.orgId)
  }

  setMenuVisible(value) {
    this.menuVisible = value
  }

  can(permission) {
    if (this.role === "superadmin") return true;

    if (this.profile) {
      switch (permission) {
        case 'superadmin':
        case 'organisations':
        case 'allchildren':
        case 'invoiceschedule':
        case 'classes_delete':
        case 'programs':
        case 'administrators':
          return false; // superadmin only

        case 'teachers':
        case 'classes_edit':
          return this.role === 'admin';

        case 'mealmenu':
          return this.role === 'admin';

        case 'invoices':
        case 'sendarchive':
          return true;

        case 'allfeatureinvoices':
          return this.role === 'admin';

        case 'dashboard':
          return this.role === 'admin' && this.profile.show_charts;

        case 'logs':
          return this.role === 'admin';

        default:
          return false;
      }
    }

    return false;
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("profile");
    localStorage.removeItem("role");
    localStorage.removeItem("orgId");
    localStorage.removeItem("last_action_time");
    this.role = null;
    this.user = null;
    this.profile = null;
    this.orgId = null;
    this.orgName = null;
    this.child_id = null;
    this.pdfFile = null;
    this.snackBar = false;
    this.addParentToChildId = null;
  }
}

const Auth = new AuthClass();
export default Auth;

